import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError } from '@as-react/common-types';
import { isOneSizeProduct, isOnlyOneSizeProduct } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { SizeSelectButtons } from '../size-select/SizeSelectButtons';
export const MiniPDPSizeSelect = ({ sizes, selectedSku, selectedColorId, sizeSelectError, onSizeSelectChange, }) => {
    const { oneSizeProductCode } = useAemConfig();
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    const isOneSizeProductInline = isOnlyOneSizeProduct(sizes);
    if (oneSizeProduct) {
        return null;
    }
    return (_jsx(Box, { paddingBlockStart: "4", children: _jsx(SizeSelectButtons, { id: "mini_pdp_product_tile_size_select", sizes: sizes, selectedSku: selectedSku, selectSize: ({ sku }) => {
                if (sku) {
                    onSizeSelectChange(sku);
                }
            }, basketValidationState: sizeSelectError && !selectedSku ? BasketButtonError.SKU : undefined, sizeRecommendation: null, selectedColorId: selectedColorId, isOneSizeProduct: false, isOneSizeProductInline: isOneSizeProductInline }) }));
};
